import { Component, Input } from '@angular/core';
import { AppStreamEnvironment } from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-env-launch-button',
  templateUrl: './launch-button.component.html',
  styleUrls: ['./launch-button.component.scss']
})
export class LaunchButtonComponent {
  @Input() env?: AppStreamEnvironment;

  canLaunch(): boolean {
    return (this.env && this.env.isAvailable && !this.env.inMaintenanceMode) === true;
  }
}
